module.exports = __webpack_public_path__ + "static/img/train-bg.8876a323.png";